import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';

// Matched on the company name so every Verano entity (Verano Nederland and the
// like) qualifies without listing ids per environment.
const VERANO_COMPANY_NAME_PART = 'verano';

// Features built for Verano only - currently the Specs page.
export const useIsVeranoCompany = (): boolean =>
  useSelector(
    (state: IRootReducerState) =>
      !!state.userInfo.company?.name
        ?.toLowerCase()
        .includes(VERANO_COMPANY_NAME_PART)
  );
